/** Team hub routes use `/team/:teamId/:section` instead of `/:scope/:section`. */
export function hubScopeFromParams<T extends string>({
  scopeParam,
  teamId,
  teamScopeValue,
  defaultScope,
}: {
  scopeParam?: string;
  teamId?: string;
  teamScopeValue: T;
  defaultScope: T;
}): T {
  if (teamId || scopeParam === teamScopeValue) {
    return teamScopeValue;
  }
  return (scopeParam as T) || defaultScope;
}
